import type { CategoryTabItem } from '@/composables/useGameCategory'

export const getGameCategoryTarget = (item: CategoryTabItem): string => {
  const code = item.code.toUpperCase()

  if (code === 'MINI') return '/mini'
  if (code === 'ISLOT') return `/game?type=${item.value}&code=ISLOT`

  return `/game?type=${item.value}`
}
